import * as React from "react";
import {MenuItem} from "../../types/Types";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCog} from "@fortawesome/free-solid-svg-icons";
import "./location/LocationMenu.css"

interface Props {
  menuItem: MenuItem,
  isAdmin: boolean,
}

function MenuItemRow(props: Props) {
  return (
    <div className={`mb-0 ${props.isAdmin ? 'basic-box colour-secondary' : 'colour-menu menu-item'}`}>
      <div className={"d-inline-block font-1-2 font-weight-500"}>{props.menuItem.description} {props.isAdmin && <FontAwesomeIcon className={"ms-1 font-black"} icon={faCog}/>}</div>
      <div className={`float-right tag font-1 ${props.isAdmin ? 'grey' : 'price-tag'} mt-1`}>{props.menuItem.price.toFixed(2)} <span>€</span></div>
      <div className={"font-md font-weight-500"}>{props.menuItem.subDescription}</div>
    </div>
  )
}

export default MenuItemRow;